import { Action, handleActions } from 'redux-actions'
import { CompanyId, UserDto } from '../../../services/api.types'
import {
  getCompanySignUpCodeSuccess,
  getCompanyUsersFail,
  getCompanyUsersSuccess,
  setCompanyUsersLoading,
} from './UserManagementActions'

class State {
  companyUsers: UserDto[] = []
  usersLoading = false
  usersLoaded = false
  signUpCodes: { [companyId: CompanyId]: string } = {}
}

export const userManagement = handleActions<State, any>(
  {
    [String(setCompanyUsersLoading)]: (state: State): State => ({
      ...state,
      companyUsers: [],
      usersLoading: true,
      usersLoaded: false,
    }),
    [String(getCompanyUsersSuccess)]: (state: State, action: Action<UserDto[]>): State => ({
      ...state,
      companyUsers: action.payload,
      usersLoading: false,
      usersLoaded: true,
    }),
    [String(getCompanyUsersFail)]: (state: State): State => ({
      ...state,
      usersLoading: false,
      usersLoaded: true,
    }),
    [String(getCompanySignUpCodeSuccess)]: (state: State, action: Action<any>): State => ({
      ...state,
      signUpCodes: {
        ...state.signUpCodes,
        [action.payload.companyId]: action.payload.signUpCode,
      },
    }),
  },
  new State(),
)

export { State as UserManagementState }
